import { render, staticRenderFns } from "./JoinOliviaIndex.vue?vue&type=template&id=2cb31e74&scoped=true&"
import script from "./JoinOliviaIndex.vue?vue&type=script&lang=js&"
export * from "./JoinOliviaIndex.vue?vue&type=script&lang=js&"
import style0 from "./JoinOliviaIndex.vue?vue&type=style&index=0&id=2cb31e74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb31e74",
  null
  
)

export default component.exports